import _ from 'lodash';
import angular from 'angular';
import template from './newEditRecruiter.html';
import Logger from '../../../shared/logger';
import UtilsService from '../../../services/utilsService';
import { RECRUITER_ROLES } from '../constants/recruiterRoles';

export class CreateEditRecruiter {
    /* @ngInject */
    constructor(
        $scope,
        $cookies,
        $state,
        $stateParams,
        RecruiterService,
        RouteService,
        $timeout,
        $window,
        permissions,
        OfficeService,
        NotificationService,
    ) {
        const newEditRecCtrl = this;
        newEditRecCtrl.VERSION = $window.VERSION;
        newEditRecCtrl.BUILD_DATE = $window.BUILD_DATE;
        newEditRecCtrl.imageFailed = false;

        newEditRecCtrl.init = function () {
            newEditRecCtrl.outSideUser = false;
            UtilsService.cookiesOverride($cookies);
            const userPrefs = UtilsService.parseJSON($cookies.get('userprefs'));
            const userData = UtilsService.parseJSON($cookies.get('userData'));

            if (!userData?.roles?.length) {
                if (userPrefs?.entityId) {
                    $state.go('register');
                    return;
                }
                RouteService.addUserData({
                    user_metadata: {
                        user_signup: 'talentExpert',
                    },
                });
                newEditRecCtrl.outSideUser = true;
            }

            if (permissions.isTalentExpertUser()) {
                newEditRecCtrl.talenyaUser = true;
            }

            newEditRecCtrl.JobTitleValuesCount = RouteService.getSystemPreference('filteredValuesCount');
            newEditRecCtrl.recruiterData = {};

            newEditRecCtrl.staticData = [
                {
                    title: 'FUNCTIONAL_ROLES',
                    field: 'functionalRoles',
                    lookupData: 'functionalRole',
                    type: 'static',
                    dropDownText: 'CHOOSE_COMPANY_SIZE',
                    subCriteria: null,
                    multiple: true,
                    selected: [
                        {
                            value: 'Talenya Bot',
                        },
                    ],
                    setAsMandatory: false,
                },
                {
                    title: 'INDUSTRY',
                    field: 'industries',
                    lookupData: 'industries',
                    type: 'static',
                    dropDownText: 'ADD_INDUSTRY',
                    subCriteria: null,
                    multiple: true,
                    selected: [],
                    setAsMandatory: false,
                }];

            if (!$stateParams.recId) {
                newEditRecCtrl.recruiterData = {
                    fullName: '',
                    maxPositions: RouteService.getSystemDefaults('maxPositionsPerTalentExpert') || 10000,
                    contact: {
                        phone: [],
                        email: [
                            {
                                type: 'Work',
                                value: '',
                            },
                        ],
                    },
                    geographicPreferences: { defaultOffice: 'OFFICE_USA' },
                    functionalRoles: [],
                    industries: [],
                    canRequestFeedbackFromEmployer: 'false',
                    roles: [],
                    title: 'Talent Specialist',
                };
                if (newEditRecCtrl.outSideUser === true) {
                    newEditRecCtrl.recruiterData.contact.email.push({
                        type: 'Work',
                        value: userData?.email,
                    });
                }
                newEditRecCtrl.isNew = true;
            } else {
                newEditRecCtrl.isNew = false;
                RecruiterService.getRecruiter($stateParams.recId)
                    .then((response) => {
                        newEditRecCtrl.recruiterData = response.result;
                        newEditRecCtrl.recruiterData.canRequestFeedbackFromEmployer = newEditRecCtrl.recruiterData.roles.indexOf('request_feedback_from_employers') >= 0 ? 'true' : 'false';
                        newEditRecCtrl.recruiterData.role = _.find(newEditRecCtrl.recruiterData.roles, (i) => i === RECRUITER_ROLES.DATA_ANALYST) || '';
                        newEditRecCtrl.staticData[0].selected = _.map(newEditRecCtrl.recruiterData.functionalRoles, (value) => ({
                            uid: '0',
                            value,
                            required: 'optional',
                        }));
                        newEditRecCtrl.staticData[1].selected = _.map(newEditRecCtrl.recruiterData.industries, (value) => ({
                            uid: '0',
                            value,
                            required: 'optional',
                        }));
                        newEditRecCtrl.active = response.result.status.current === 'active';
                    })
                    .catch((error) => Logger.error(error));
            }
        };

        newEditRecCtrl.addNewPhone = function () {
            newEditRecCtrl.recruiterData.contact.phone.push({
                type: 'Mobile',
                value: '',
            });
        };

        newEditRecCtrl.removePhone = function (index) {
            newEditRecCtrl.recruiterData.contact.phone.splice(index, 1);
        };

        newEditRecCtrl.addNewEmail = function () {
            newEditRecCtrl.recruiterData.contact.email.push({
                type: 'Work',
                value: '',
            });
        };

        newEditRecCtrl.removeEmail = function (index) {
            newEditRecCtrl.recruiterData.contact.email.splice(index, 1);
        };

        newEditRecCtrl.cancel = function () {
            if (newEditRecCtrl.outSideUser) {
                $window.history.back();
                $window.history.back();
            } else if (newEditRecCtrl.isNew) {
                $state.go('talenya.jobs');
            } else {
                $state.go('recruiter.positions');
            }
        };

        newEditRecCtrl.isImage = function (src) {
            if (!src) {
                newEditRecCtrl.imageFailed = true;
                return;
            }
            // eslint-disable-next-line no-undef
            const image = new Image();
            image.src = src;

            image.onerror = function () {
                $timeout(() => {
                    newEditRecCtrl.imageFailed = true;
                });
            };
            image.onload = function () {
                $timeout(() => {
                    newEditRecCtrl.imageFailed = false;
                });
            };
        };

        newEditRecCtrl.manageRolesPromise = function (recruiterId) {
            const shouldAddRole = newEditRecCtrl.recruiterData.canRequestFeedbackFromEmployer == 'true'
                && newEditRecCtrl.recruiterData.roles.indexOf('request_feedback_from_employers') < 0;

            const shouldRemoveRole = newEditRecCtrl.recruiterData.canRequestFeedbackFromEmployer == 'false'
                && newEditRecCtrl.recruiterData.roles.indexOf('request_feedback_from_employers') >= 0;

            if (shouldAddRole) {
                return RecruiterService.addRole(recruiterId, 'request_feedback_from_employers');
            }
            if (shouldRemoveRole) {
                return RecruiterService.removeRole(recruiterId, 'request_feedback_from_employers');
            }

            // eslint-disable-next-line no-undef
            return Promise.resolve();
        };

        newEditRecCtrl.setStatus = function (status) {
            RecruiterService.setStatus($stateParams.recId, status)
                .then(() => {
                    $state.go('recruiter.positions', { recruiterId: $stateParams.recId }, { reload: true });
                })
                .catch((error) => Logger.error(error));
        };

        newEditRecCtrl.save = function (form) {
            if (form.$invalid) {
                angular.forEach(form.$error, (field) => {
                    angular.forEach(field, (errorField) => {
                        errorField.$setTouched();
                    });
                });
                NotificationService.error('PLEASE_FILL_REQUIRED_FIELDS');
                return;
            }
            newEditRecCtrl.recruiterData.functionalRoles = _.map(newEditRecCtrl.staticData[0].selected, 'value');
            newEditRecCtrl.recruiterData.industries = _.map(newEditRecCtrl.staticData[1].selected, 'value');
            if (newEditRecCtrl.isNew == true) {
                RecruiterService.postRecruiter(newEditRecCtrl.recruiterData)
                    .then((response) => {
                        if (newEditRecCtrl.outSideUser) {
                            $state.go('register');
                            return;
                        }
                        NotificationService.success(`${response.result.contact?.email[0]?.value || 'User'} created`);
                        $state.go('recruiter.positions', { recruiterId: response.result._id }, { reload: true });
                    })
                    .catch((error) => Logger.error(error));
            } else {
                RecruiterService.putRecruiter($stateParams.recId, newEditRecCtrl.recruiterData)
                    .then(() => {
                        $state.go('recruiter.positions', { recruiterId: $stateParams.recId }, { reload: true });
                    })
                    .catch((error) => Logger.error(error));
            }
        };

        newEditRecCtrl.onOfficeChange = ({ value }) => {
            newEditRecCtrl.recruiterData.geographicPreferences.defaultOffice = value;
        };

        newEditRecCtrl.onRoleChange = ({ value }) => {
            const roleOptions = _.map(newEditRecCtrl.roleOptions, 'value');
            newEditRecCtrl.recruiterData.roles = _.chain(newEditRecCtrl.recruiterData.roles)
                .difference(roleOptions)
                .push(value)
                .filter(Boolean)
                .value();
                newEditRecCtrl.recruiterData.role = value;
        };

        newEditRecCtrl.$onInit = async () => {
            newEditRecCtrl.roleOptions = [
                { label: 'TALENT_EXPERT', value: '' },
                { label: 'DATA_ANALYST', value: RECRUITER_ROLES.DATA_ANALYST },
            ];
            const { result } = await OfficeService.getOffices();

            newEditRecCtrl.officeOptions = (result || []).map((office) => ({ label: office, value: office }));
        };

        newEditRecCtrl.init();
    }
}

export const CreateEditRecruiterConfiguration = {
    template,
    controller: CreateEditRecruiter,
    controllerAs: 'newEditRecCtrl',
};

angular
    .module('TALENYA-FE')
    .component('createEditRecruiter', CreateEditRecruiterConfiguration);
